function imageUrlFromSignedBlobId(signedBlobId) {
  if (window.ENV.CDN_DOMAIN) {
    return `${window.ENV.CDN_DOMAIN}/rails/active_storage/blobs/${signedBlobId}/image.png?client_id=${window.ENV.CLIENT_ID}`
  } else {
    return `/rails/active_storage/blobs/${signedBlobId}/image.png?client_id=${window.ENV.CLIENT_ID}`
  }
}

export default imageUrlFromSignedBlobId
